import { useEffect, useState } from "react";
import api from "../lib/api";
import { toast } from "sonner";
import { Sparkles, Check, X } from "lucide-react";

const inp = "border border-[#DFDAD0] px-2 py-1 text-xs bg-white outline-none focus:border-[#1C2530]";

function Row({ s, meta, onDone }) {
  const [cat, setCat] = useState("Training Vendor");
  const [dom, setDom] = useState("");
  const [busy, setBusy] = useState(false);
  const needsDomain = (meta?.domain_categories || ["Trainer", "Training Vendor"]).includes(cat);
  const accept = async () => {
    if (needsDomain && !dom) { toast.error("Pick a training domain"); return; }
    setBusy(true);
    try { await api.post(`/vendors/suggestions/${s.id}/accept`, { category: cat, domain: dom || null }); toast.success(`${s.name} added to Vendor Directory`); onDone(); }
    catch (e) { toast.error(e.response?.data?.detail || "Failed"); } finally { setBusy(false); }
  };
  const dismiss = async () => {
    setBusy(true);
    try { await api.post(`/vendors/suggestions/${s.id}/dismiss`); onDone(); }
    catch (e) { toast.error(e.response?.data?.detail || "Failed"); } finally { setBusy(false); }
  };
  return (
    <div className="flex flex-wrap items-center gap-2 px-4 py-2.5 border-t border-[#DFDAD0]" data-testid={`vendor-suggestion-${s.id}`}>
      <div className="flex-1 min-w-[200px]">
        <div className="text-sm font-medium text-[#1C2530]">{s.name} <span className="font-mono text-[10px] text-[#1C2530]/50">· {s.email}</span></div>
        <div className="text-[11px] text-[#1C2530]/55">{s.reason} · found in {s.found_by_name}'s sent mail</div>
      </div>
      <select value={cat} onChange={(e) => setCat(e.target.value)} data-testid={`vsug-cat-${s.id}`} className={inp}>
        {(meta?.categories || []).map((c) => <option key={c} value={c}>{c}</option>)}
      </select>
      {needsDomain && (
        <select value={dom} onChange={(e) => setDom(e.target.value)} data-testid={`vsug-domain-${s.id}`} className={inp}>
          <option value="">Training domain…</option>
          {(meta?.domains || []).map((d) => <option key={d} value={d}>{d}</option>)}
        </select>
      )}
      <button onClick={accept} disabled={busy} data-testid={`vsug-accept-${s.id}`} className="flex items-center gap-1 border border-[#2F7A3E] text-[#2F7A3E] px-2 py-1 font-mono text-[9px] uppercase hover:bg-[#2F7A3E]/10 disabled:opacity-40"><Check className="w-3 h-3" /> Add vendor</button>
      <button onClick={dismiss} disabled={busy} data-testid={`vsug-dismiss-${s.id}`} className="flex items-center gap-1 border border-[#DFDAD0] text-[#1C2530]/60 px-2 py-1 font-mono text-[9px] uppercase hover:bg-[#EFECE5] disabled:opacity-40"><X className="w-3 h-3" /> Not a vendor</button>
    </div>
  );
}

export default function VendorSuggestions({ meta, onAccepted }) {
  const [rows, setRows] = useState(null);
  const load = () => api.get("/vendors/suggestions").then((r) => setRows(r.data)).catch(() => setRows([]));
  useEffect(() => { load(); }, []);
  if (!rows || rows.length === 0) return null;
  return (
    <div className="border border-[#3E8F99]/40 bg-[#3E8F99]/5" data-testid="vendor-suggestions">
      <div className="flex items-center gap-2 px-4 py-2.5 font-mono text-[10px] uppercase tracking-wider text-[#3E8F99]">
        <Sparkles className="w-3.5 h-3.5" /> Suggested vendors from mailbox scans · {rows.length} to review
        <span className="ml-auto normal-case tracking-normal text-[#1C2530]/50 font-sans text-[11px]">Suppliers spotted in sent mail are held here — nothing is added until you confirm.</span>
      </div>
      {rows.map((s) => <Row key={s.id} s={s} meta={meta} onDone={() => { load(); onAccepted?.(); }} />)}
    </div>
  );
}
